import * as ChaptersBlogListing from './ChaptersBlogListing';
//import { createStore, combineReducers } from "redux";
import { createBrowserHistory } from 'history';
import configureStore from './configureStore';

export interface ApplicationState {
    chaptersBlogListing: ChaptersBlogListing.IState | undefined;
}

export const reducers = {
    chaptersBlogListing: ChaptersBlogListing.reducer
}

/*export const reducers = combineReducers({
    chaptersBlogListing: ChaptersBlogListing.reducer
});*/

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
export interface AppThunkActionAsync<TAction, TResult> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): Promise<TResult>;
}

// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory();

export const store = configureStore(history);

//export default store;